import { useQuery } from '@tanstack/react-query';
import { type AxiosError } from 'axios';

import { QUERY_KEYS } from 'hb-react/frontoffice/apps/Forum/constants';
import { getCategories } from 'hb-react/frontoffice/apps/Forum/requests';
import {
  type Category,
  type ConfigUrls,
} from 'hb-react/frontoffice/apps/Forum/types';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';

export const useGetCategories = (
  configUrls: Pick<ConfigUrls, 'getCategoriesPath'>,
) => {
  const { topicId } = useTopicContext();
  const { data: categories = [], isLoading } = useQuery<Array<Category>, AxiosError>(
    {
      queryKey: [QUERY_KEYS.categories, topicId],
      queryFn: () => getCategories(configUrls),
    },
  );

  return { categories, isLoading };
};
